import type { ApolloClient } from '@apollo/client';
import { graphql } from '@/gql';

/**
 * Blue accent for receipt download (pairs with brand pink).
 * Uses `!` so colors win over {@link Button} `outline` variant (`clsx` does not merge Tailwind conflicts).
 */
export const STAFF_RECEIPT_GRID_BUTTON_CLASS =
  '!border-transparent !bg-sky-600 !text-white shadow-sm hover:!bg-sky-700 focus-visible:!bg-sky-700 disabled:!bg-sky-400/70 disabled:!text-white/90 dark:!border-transparent dark:!bg-sky-600 dark:!text-white dark:hover:!bg-sky-500 dark:disabled:!bg-sky-800 dark:disabled:!text-white/80';

const PrepareReceiptDoc = graphql(/* GraphQL */ `
  mutation PrepareReceipt($input: PrepareReceiptInput!) {
    prepareReceipt(input: $input) {
      url
      expiresAt
    }
  }
`);

/**
 * Issues a public receipt token via Go and redirects to the Guest receipt page
 * (same customer download/email flow as the POS QR).
 */
export async function openStaffOrderReceipt(
  client: ApolloClient,
  orderId: string,
): Promise<void> {
  await openStaffReceipt(client, { orderId });
}

export async function openStaffTabReceipt(client: ApolloClient, tabId: string): Promise<void> {
  await openStaffReceipt(client, { tabId });
}

async function openStaffReceipt(
  client: ApolloClient,
  input: { orderId?: string; tabId?: string },
): Promise<void> {
  const { data } = await client.mutate({
    mutation: PrepareReceiptDoc,
    variables: { input },
  });
  const url = data?.prepareReceipt?.url;
  if (!url) {
    throw new Error('Could not prepare receipt link.');
  }
  // Do not pass "noopener" as a window feature: browsers then return null even
  // when the tab opens successfully. Clear opener manually instead.
  const opened = window.open(url, '_blank');
  if (opened) {
    opened.opener = null;
  }
}
